// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"37378fce","16":"e7f772ca","203":"1fea0725","286":"ca8063fd","355":"551fe39a","413":"6f7fb9c2","766":"30c17bed"}[chunkId] + ".chunk.js";
};